<div class="select-input" [ngClass]="{ disabled: isDisabled || control.disabled }">
  <label class="heavy-label" [style.color]="control && control.errors && control.dirty ? '#C01933' : 'black'">{{ label }}</label>
  <div class="icon-arrow" [style.left]="width ? width - 15 + 'px' : '65px'" [style.top]="arrowTop ? arrowTop : ''">
    @if (showDropdownArrow) {
      <emt-delta-icon
        iconName="icon-arrow-down-icon"
        height="9"
        width="16"
        [fill]="isDisabled && 'lightgrey'"
        [flip]="isOpen"
      ></emt-delta-icon>
    }
  </div>

  @if (isMultiSelect && selectedDropdownItems) {
    <span
      class="clear-selections-button"
      (click)="clearSelected()"
      aria-hidden="true"
      [style.left]="width ? width - 28 + 'px' : '52px'"
      >
      ×
    </span>
  }

  <ng-select
    #ngSelect
    class="custom-dropdown-v2"
    [ngClass]="control && control.errors && control.dirty && 'error-custom-dropdown-v2'"
    [style.width]="width ? width + 'px' : '80px'"
    [placeholder]="placeholder"
    [items]="optionList"
    bindLabel="label"
    bindValue="value"
    [formControl]="control"
    [multiple]="isMultiSelect"
    [closeOnSelect]="!isMultiSelect"
    [selectableGroup]="selectableGroup"
    [groupBy]="groupBy"
    [selectableGroupAsModel]="false"
    [searchFn]="searchFn"
    (change)="onChange($event)"
    (add)="onAdd($event)"
    >
    @if (isMultiSelect) {
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <label class="selected-value-container">
          {{ item.label }}
          <input
            checked="checked"
            id="item-{{ index }}"
            type="checkbox"
            [ngModel]="item$.selected"
            [ngModelOptions]="{ standalone: true }"
            />
          <span class="checkmark"></span>
          <label class="selected-value-container">{{ item.subLabel }}</label>
        </label>
      </ng-template>
      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
        <label class="selected-value-container">
          {{ item.group }}
          <input
            checked="checked"
            id="item-{{ index }}"
            type="checkbox"
            [ngModel]="item$.selected"
            [ngModelOptions]="{ standalone: true }"
            />
          <span class="checkmark"></span>
          <label class="selected-value-container">{{ item.subLabel }}</label>
        </label>
      </ng-template>
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        @for (item of (items ? items.slice().reverse() : []) | slice: 0:itemCount; track item) {
          <div class="ng-value">
            <span class="ng-value-label">{{ item.label }}</span>
            <span class="ng-value-icon right" (click)="clearItem(item)" aria-hidden="true">×</span>
          </div>
        }
      </ng-template>
    }
  </ng-select>
  @if (isMultiSelect && selectedDropdownItems) {
    <div class="selected-dropdown-items">Selected: {{ selectedDropdownItems }}</div>
  }
  @if (control && control.errors && control.dirty) {
    <div class="error-msg">
      <emt-delta-icon iconName="circle-x"></emt-delta-icon>
      Please enter a value
    </div>
  }
</div>
